import * as React from "react";

const headerItems = [
    { text: "번호", width: "60px", icon: null },
    { text: "이름", width: "90px", icon: "/images/icon-user.svg" },
    { text: "학습 일시", width: "120px", icon: "/images/icon-calendar.svg" },
    { text: "학습 유무", width: "150px", icon: "/images/icon-pencil.svg" },
    { text: "학습 시간", width: "110px", icon: "/images/icon-clock.svg" },
    { text: "정확도", width: "100px", icon: "/images/icon-target-arrow.svg" },
    { text: "학습결과 분석", width: "360px", icon: "/images/icon-result.svg", minWidth: "240px" }
];

const TableHeader = () => {
    return (
        <thead>
            <tr className="flex flex-wrap items-center text-base font-semibold bg-sky-50 rounded-t-3xl text-slate-400 max-md:max-w-full">
                {headerItems.map((item, index) => (
                    <th
                        key={index}
                        className="flex gap-1 justify-center items-center self-stretch px-2 py-5 my-auto min-h-[56px]"
                        style={{ width: item.width, minWidth: item.minWidth }}
                    >
                        {item.icon && (
                            <img
                                loading="lazy"
                                src={`${item.icon}`}
                                alt="icon"
                                className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                            />
                        )}
                        <div className="self-stretch my-auto">{item.text}</div>
                    </th>
                ))}
            </tr>
        </thead>
    );
}

export default TableHeader;